import React from 'react';
// import './App.css'; // Optional – only if you want separate footer CSS

function Footer() {
  return (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-text">
          © 2024 FlightSearch AI. All rights reserved.
        </div>
        <div className="footer-links">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms">Terms</a>
          <a href="/cookie-policy">Cookies</a>
          <a href="/ccpa">CCPA</a>
          <a href="/affiliate-disclosure">Affiliate Disclosure</a>
          <a href="/disclaimer">Disclaimer</a>
        </div>
      </div>
    </div>
  );
}

export default Footer;


